/* src/app/shared/components/column-template/column-template.component.scss */
.div-container {
  margin-bottom: 24px;
}
.split-column {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.column {
  flex-direction: column;
  display: flex;
  min-width: 97%;
  margin-right: 24px;
}
.column-item {
  margin-bottom: 24px;
}
/*# sourceMappingURL=column-template.component.css.map */
